export const fonts = {
	amiko: "'Amiko', sans-serif",
	arvo: "'Arvo', serif",
	baskerville: "'Libre Baskerville', serif",
};
